<template>
  <div
    class="interaction"
    :style="
      isDesktop && (hasDesktopBackground || isCloudflareVideo)
        ? style
        : !isDesktop
        ? style
        : null
    "
  >
    <div
      class="interaction-wrapper"
      :class="{
        'interaction-wrapper_desktop':
          isDesktop && (hasDesktopBackground || isCloudflareVideo),
      }"
      :style="isDesktop && !hasDesktopBackground ? style : null"
    >
      <span v-if="canComment || preview" style="height: 100%">
        <app-comment-button
          v-if="!commentMode"
          @click="openComment"
          :positioning="buttonPositioning"
        ></app-comment-button>

        <app-comment-form
          v-if="commentMode"
          :preview="preview"
          @sent="onCommentSend"
        ></app-comment-form>
      </span>

      <spinner v-if="loading" size="large"></spinner>
      <div v-if="loading" class="mascara-spinner"></div>

      <app-close
        :comment-mode="commentMode"
        @next="next(null)"
        @close-comment="closeComment"
        :countdown="countdown"
        :countdownEnded="countdownEnded"
        @count-over="onCountOver"
        :videoMinimumTime="videoMinimumTime"
        :positioning="buttonPositioning"
      ></app-close>

      <div class="interaction-wrapper-type" v-show="!commentMode">
        <dialog class="interaction-wrapper-type-dialog">
          {{  dialogMessage }}
        </dialog>

        <app-banner
          v-if="isBanner"
          :key="interactionData.id"
          :data-interaction="interactionData"
          :areActionsHidden="countdown && !countdownEnded"
          @next="next"
          @on-countdown-init="countdown = true"
          @on-copy="showSuccessMessage"
        ></app-banner>

        <app-poll
          v-if="isPoll"
          :data-interaction="interactionData"
          @next="next"
        ></app-poll>

        <app-nps
          v-if="isNps"
          :data-interaction="interactionData"
          @next="next"
        ></app-nps>

        <app-open-field
          v-if="isOpenField"
          :data-interaction="interactionData"
          @next="next"
          :isDesktop="isDesktop"
        ></app-open-field>

        <app-coupon-preview
          v-if="isCoupon"
          :data-interaction="interactionData"
          @next="next"
        />

        <app-video
          v-if="isVideo"
          :data-interaction="interactionData"
          @next="next"
          @on-countdown-init="countdown = true"
          :areActionsHidden="countdown && !countdownEnded"
          :button-positioning="buttonPositioning"
          :comment-mode="commentMode"
          :background="background"
          :isDesktop="isDesktop"
        />

        <app-interaction-preview-ads
          v-if="isAds"
          :data-interaction="interactionData"
          @next="next"
        />
      </div>

      <img
        v-if="!canRemovePoweredByWifeed"
        :src="poweredByWifeed"
        class="powered-by-wifeed"
      />
    </div>
  </div>
</template>

<script>
import AppCommentForm from "./components/CommentForm";
import AppCommentButton from "./components/CommentButton";
import AppClose from "./components/Close";
import AppBanner from "./components/Banner";
import AppNps from "./components/Nps";
import AppPoll from "./components/Poll";
import AppCouponPreview from "./components/CouponPreview";
import AppInteractionPreviewAds from "./components/ads/InteractionPreviewAds.vue";
import AppVideo from "./components/Video";
import AppOpenField from "./components/OpenField";
import dataInteractionProp from "./mixins/data-interaction-prop";
import videoCampaign from "../../../../packages/mixins/video-campaign";
import Spinner from "vue-simple-spinner";
import poweredByWifeed from "@assets/images/powered-by-wifeed.png";
import rgbaToCss from "../../../../packages/mixins/rgba-to-css";

export default {
  mixins: [dataInteractionProp, rgbaToCss, videoCampaign],

  components: {
    AppCommentButton,
    AppCommentForm,
    AppClose,
    AppBanner,
    AppNps,
    AppPoll,
    Spinner,
    AppCouponPreview,
    AppVideo,
    AppOpenField,
    AppInteractionPreviewAds
  },

  metaInfo: {
    script: [
      {
        src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
        crossOrigin: 'anonymous',
        async: true
      },    
    ],    
  },

  data() {
    return {
      commentMode: false,
      commentSent: false,
      poweredByWifeed,
      imageMaxHeight: "auto",

      done: false,
      countdown: false,

      isPaused: false,
      interactionId: +new Date(),
      videoContainerWidth: undefined,
      windowWidth: undefined,
      countdownEnded: false,
      dialogMessage: undefined,
      showDialogTimeut: undefined
    };
  },

  props: {
    preview: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      required: false,
      default: false,
    },
    isStatisticsPreview: {
      type: Boolean,
      default: false,
    },
    isCampaignsListPreview: {
      type: Boolean,
      default: false,
    },
    isPreviewOpen: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isDesktop() {
      this.setBackgroundImageMaxHeight();
    },
  },

  computed: {
    hasDesktopBackground() {
      return !!this.backgroundDesktop;
    },

    backgroundMobile() {
      return this.interaction && this.interaction.mediaMobile;
    },

    hasBackgroundMobileImage() {
      let hasBackgroundMobileImage;
      if (this.isCloudflareVideo) {
        hasBackgroundMobileImage = false;
      } else {
        hasBackgroundMobileImage =
          this.backgroundMobile.split("background/")[1] !== "null";
      }
      return hasBackgroundMobileImage;
    },

    backgroundDesktop() {
      return this.interaction.mediaDesktop;
    },

    background() {
      if (!this.interaction) {
        return;
      }

      return this.isStatisticsPreview
        ? this.interaction.mediaMobile
        : this.isDesktop && this.hasDesktopBackground
        ? this.interaction.mediaDesktop
        : this.interaction.mediaMobile;
    },

    backgroundColorInteraction() {
      return this.interaction.estilo
        ? this.interaction.estilo.backgroundColorInteraction.color
        : null;
    },

    isBanner() {
      return this.interaction.tipo === "BANNER";
    },

    isPoll() {
      return this.interaction.tipo === "PESQUISA_OBJETIVA";
    },

    isNps() {
      return this.interaction.tipo === "PESQUISA_NPS";
    },

    isOpenField() {
      return this.interaction.tipo === "OPEN_FIELD";
    },

    isCoupon() {
      return this.interaction.tipo === "CODIGO_PROMOCIONAL";
    },

    isAds() {
      return this.interaction.tipo === "GOOGLE_PUBLISHER_TAG" || this.interaction.tipo === "VAST";
    },

    style() {
      const styleObj = {
        "background-size": "cover",
        "grid-column-start": this.interaction.posicaoX,
        "grid-row-start": this.interaction.posicaoY,
        "background-position": "center",
        "max-height": this.imageMaxHeight,
        width: this.isStatisticsPreview
          ? "337px"
          : this.isDesktop &&
            (this.hasDesktopBackground || this.isCloudflareVideo)
          ? "100%"
          : "460px",
        "background-color": this.isVideo ? "#000000" : "",
      };
      let newPropertiesObj;

      if (this.hasBackgroundMobileImage) {
        newPropertiesObj = { "background-image": `url(${this.background})` };
      } else if (!this.isCloudflareVideo) {
        newPropertiesObj =
          typeof this.backgroundColorInteraction === "object"
            ? {
                "background-color": this.rgbaToCss(
                  this.backgroundColorInteraction
                ),
              }
            : { background: this.backgroundColorInteraction };
      }

      return this.isVideo
        ? styleObj
        : Object.assign(styleObj, newPropertiesObj);
    },

    canComment() {
      return (
        !!this.interaction &&
        this.interaction.mostrarComentario &&
        !this.commentSent
      );
    },

    user() {
      return this.$store.state.users.user;
    },

    permissions() {
      return this.user.permissions;
    },

    canRemovePoweredByWifeed() {
      return this.permissions.find((x) => x === "REMOVE_POWERED_BY_WIFEED");
    },

    isPreviewOpenComputed() {
      return this.isPreviewOpen;
    },

    videoMinimumTime() {
      return this.interaction.minimumTime;
    },

    interactionStored() {
      return this.$store.state.interactions.list.find(
        (interaction) => interaction.id === this.interaction.id
      );
    },

    interactionData() {
      return this.isStatisticsPreview || this.isCampaignsListPreview
        ? this.interaction
        : this.interactionStored;
    },

    buttonPositioning() {
      return this.isDesktop &&
        (this.hasDesktopBackground || this.isCloudflareVideo)
        ? (this.windowWidth - this.videoContainerWidth) / 2
        : 0;
    },

    isDesktopMode() {
      return this.isDesktop;
    },
  },

  mounted() {
    this.setWindowAndVideoContainerWidth();
    window.addEventListener("resize", this.setWindowAndVideoContainerWidth);

    if (this.isDesktop) {
      this.setBackgroundImageMaxHeight();
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setWindowAndVideoContainerWidth);
  },

  methods: {
    showSuccessMessage(message) {
      if(this.showDialogTimeut) {
        clearTimeout(this.showDialogTimeut)
      }

      this.dialogMessage = message;
      document.querySelector("dialog").show();

      this.showDialogTimeut = setTimeout(() => {
        document.querySelector("dialog").close();
      }, 2500)
    },

    openComment() {
      this.commentMode = true;
      this.countdown = false;
    },

    closeComment() {
      this.commentMode = false;     
      this.countdown = true;      
    },

    onCountOver() {
      this.countdown = false;
      this.countdownEnded = true
    },

    next(optionId) {
      this.countdown = false;
      this.countdownEnded = false;
      this.$emit("next", optionId);
    },

    onCommentSend() {
      this.commentSent = true;
      this.commentMode = false;
    },

    setBackgroundImageMaxHeight() {
      if (this.isDesktop && !this.interaction.backgroundDesktop) {
        const img = new Image();

        img.onload = () => {
          this.imageMaxHeight = "100vh";
        };

        img.src = this.interaction.backgroundMobile;
      } else {
        this.imageMaxHeight = "auto";
      }
    },

    setWindowAndVideoContainerWidth() {
      this.videoContainerWidth = window.innerHeight * 1.77;
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@variables";

.powered-by-wifeed {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%) scale(0.75);
}

.mascara-spinner {
  position: absolute !important;
  top: 0% !important;
  left: 0% !important;
  width: 100%;
  height: 100%;
  z-index: 99999999;
  background: #00000038;
}

.interaction {
  .interaction-wrapper {
    .btn-volume {
      top: 10px;
    }

    .interaction-wrapper-type {
      height: 100%;

      .interaction-wrapper-type-dialog {
        z-index: 10;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        width: 70%;
        font-size: 14px;
        text-align: center;
        border: none;
        color: white;
        background: $success;
        outline: none;
        padding: 10px 5px;
        border-radius: 8px;
      }
    }

    &.interaction-wrapper_desktop {
      width: 100%;

      ::v-deep .banner-actions {
        max-width: 414px;
        margin: 0 auto;
        width: 414px;
      }

      ::v-deep .btn {
        min-width: auto !important;
        padding-right: 50px;
        padding-left: 50px;
        width: auto;

        &.poll-action {
          width: 414px;
        }
      }
    }
  }
}
</style>
